import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import {
  ApiUserAdmin,
  endpoints_auditAdmin,
  endpoints_clientResponse,
} from "src/app/api";

const api = new ApiUserAdmin();

export const getReports = createAsyncThunk(
  "reportApp/report/getReports",
  async (params) => {
    const response = await api.get(endpoints_auditAdmin.AUDIT());
    return { data: response };
  }
);

export const getClientResponses = createAsyncThunk(
  "reportApp/report/getClientResponses",
  async (reportId) => {
    const responses = await api.get(
      endpoints_clientResponse.CLIENT_RESPONSE_AUDIT(reportId)
    );

    return {
      reportId,
      responses: responses, // importante: nunca undefined
    };
  }
);

export const addReport = createAsyncThunk(
  "reportApp/report/addReport",
  async (newReport, { rejectWithValue }) => {
    // const response = await api.post(endpoints_userAdmin.CONTENT, newContent);
    // return { data: response };
  }
);

export const getReportByLocalId = createAsyncThunk(
  "reportApp/report/getReportByLocalId",
  async (id) => {
    const data = await api.post(endpoints_auditAdmin.AUDIT_BY_LOCAL, {
      local_id: id,
    });
    return { data };
  }
);

export const getReportById = createAsyncThunk(
  "reportApp/report/getReportById",
  async (id) => {
    const data = await api.post(endpoints_auditAdmin.AUDIT_BY_ID, {
      id,
    });

    return { data };
  }
);

export const addClientResponse = createAsyncThunk(
  "reportApp/report/addClientResponse",
  async ({ auditId, subformIndex, comment, photo }) => {
    const response = await api.postUpload(
      endpoints_clientResponse.CLIENT_RESPONSE,
      { auditId, subformIndex, comment, photo }
    );
    return { reportId, response };
  }
);

const reportAdapter = createEntityAdapter();

const reportSlice = createSlice({
  name: "reportApp/report",
  initialState: reportAdapter.getInitialState({
    selectedReportId: null,
  }),
  reducers: {
    clearSelectedReport: (state) => {
      state.selectedReportId = null;
    },
    setSelectedReport: (state, action) => {
      state.selectedReportId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReports.fulfilled, (state, action) => {
        reportAdapter.setAll(state, action.payload.data);
      })
      .addCase(addReport.fulfilled, (state, action) => {
        reportAdapter.addOne(state, action.payload.data);
      })
      .addCase(getReportById.fulfilled, (state, action) => {
        reportAdapter.upsertOne(state, action.payload.data);
      })
      .addCase(getReportByLocalId.fulfilled, (state, action) => {
        reportAdapter.setAll(state, action.payload.data);
      })
      .addCase(getClientResponses.fulfilled, (state, action) => {
        const { reportId, responses } = action.payload;
        const report = state.entities[reportId];
        if (report) {
          report.clientResponses = responses;
        }
      })
      .addCase(addClientResponse.fulfilled, (state, action) => {
        const { reportId, response } = action.payload;
        const report = state.entities[reportId];
        if (report) {
          if (!report.clientResponses) report.clientResponses = [];
          report.clientResponses.push(response);
        }
      });
  },
});

export const { clearSelectedReport, setSelectedReport } = reportSlice.actions;

// Selectores generados automáticamente
export const { selectAll: selectReport, selectById: selectReportById } =
  reportAdapter.getSelectors((state) => state.reportApp.report);

export const selectSelectedReport = (state) => {
  const id = state.reportApp.report.selectedReportId;
  return id ? selectReportById(state, id) : null;
};

export default reportSlice.reducer;
